interface PriceChangeProps {
  change: number;
  changePercent: number;
  showPercent?: boolean;
  className?: string;
}

export default function PriceChange({ change, changePercent, showPercent = true, className = '' }: PriceChangeProps) {
  const isUp = change >= 0;
  return (
    <span
      className={`inline-flex items-center gap-1 text-sm font-semibold whitespace-nowrap ${
        isUp ? 'text-emerald-500' : 'text-rose-500'
      } ${className}`}
    >
      <i className={`${isUp ? 'ri-arrow-up-line' : 'ri-arrow-down-line'} text-base w-4 h-4 flex items-center justify-center`}></i>
      <span>
        {isUp ? '+' : ''}
        {change.toLocaleString('vi-VN')}
        {showPercent && ` (${isUp ? '+' : ''}${changePercent.toFixed(2)}%)`}
      </span>
    </span>
  );
}